export const PERSISTED_QUERY_NOT_FOUND_CODE = 'PERSISTED_QUERY_NOT_FOUND';
